<template>
  <footer class="footer" v-if="hasDataInFooter">
    <div class="footer-copyright container">
      <template v-if="hasLogosCompany">
        <p v-for="logo in logos" :key="logo.id"
          class="logo"
        >
          <img
            class="img-fluid"
            :src="logo"
            alt="logo company"
            title="logo company"
          />
      </p>
      </template>
      <p>© {{ new Date().getFullYear() }} Zonesoft</p>
      <div class="footer-copyright__terms" v-if="hasLegalInformation">
        <div
          v-for="legalInformation in hasLegalInformation"
          :key="legalInformation.id"
          class="footer-copyright__terms__div"
        >
          <a
            v-if="legalInformation.is_external_link"
            :href="legalInformation.redirect_external_link"
            target="_blank"
            rel="noopener"
          >
            <p>{{ legalInformation.title }}</p>
          </a>
          <RouterLink
            v-else
            :to="{
              name: 'terms',
              params: {
                slug: legalInformation.page_slug,
              },
            }"
          >
            {{ legalInformation.title }}
          </RouterLink>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { axiosInstance } from "@/plugins/axios-instance";

export default {
  computed: {
    hasDataInFooter() {
      return this.dataFooter && Object.keys(this.dataFooter).length > 0;
    },
    hasLogosCompany() {
      return this.logos?.length > 0;
    },
    hasLegalInformation() {
      const legalInformationLinks = this.dataFooter["legal_information"]?.links;
      const dataLegalInformation = [legalInformationLinks];
      if (dataLegalInformation.length > 0) {
        return dataLegalInformation[0];
      }
      return false;
    },
  },
  data() {
    return {
      dataFooter: {},
      logos: {},
    };
  },
  mounted() {
    this.getDataFooter();
  },
  methods: {
    async getDataFooter() {
      const { data } = await axiosInstance({
        method: "POST",
        url: "/footer",
      });

      this.dataFooter = data?.data?.sections;
      this.logos = data?.data?.logos;
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  background: var(--black-light);
  height: 190px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 991px) {
    height: initial;
    padding: 30px 0;
  }
  // @media (min-width: 992px) {
  //   &:before {
  //     content: "";
  //     display: block;
  //     position: absolute;
  //     left: 0;
  //     top: -696px;
  //     width: 362px;
  //     height: 1020px;
  //     background: url("~@/assets/img/bg-footer.png");
  //     background-repeat: no-repeat;
  //     background-size: cover;
  //     background-position: center;
  //     z-index: -1;
  //   }
  // }
  &-sections {
    display: flex;
    @media (max-width: 991px) {
      flex-direction: column;
    }
    &-contact {
      width: 25%;
      border-right: 1px solid var(--gray);
      @media (max-width: 991px) {
        width: 100%;
        border-right: 0;
        border-bottom: 1px solid var(--gray);
        padding-bottom: 30px;
      }
      .title {
        font-size: 22px;
        font-family: "Font Bold";
        color: var(--white);
        padding: 25px 20px;
        border-bottom: 1px solid var(--gray);
        margin-bottom: 0;
        @media (min-width: 992px) and (max-width: 1199px) {
          padding: 15px;
          font-size: 18px;
        }
        @media (max-width: 991px) {
          border-bottom: 0;
          padding: 0;
        }
      }
      &__body {
        padding: 45px 20px 0 20px;
        @media (max-width: 991px) {
          padding: 30px 0 0 0;
        }
        .links {
          display: flex;
          text-decoration: none;
          margin-bottom: 40px;
          transition: 500ms;
          &:hover,
          &:focus {
            cursor: pointer;
            opacity: 0.8;
          }
          img {
            max-width: 22px;
            max-height: 22px;
          }
          .text {
            margin-left: 15px;
            &__primary {
              font-size: 16px;
              font-family: "Font Light";
              color: var(--white);
              line-height: 1;
              margin-bottom: 0;
            }
            &__secondary {
              font-size: 16px;
              font-family: "Font Light";
              color: rgba(255, 255, 255, 0.5);
              margin-top: 5px;
              margin-bottom: 0;
            }
          }
        }
        .sociais {
          display: flex;
          align-items: center;
          margin-bottom: 35px;
          a {
            margin-right: 23px;
            img {
              max-width: 43px;
              max-height: 43px;
            }
          }
        }
        .logo {
          display: flex;
          align-items: center;
          img:not(:first-child) {
            margin-left: 23px;
          }
        }
      }
    }
    &-solutions {
      width: 25%;
      border-right: 1px solid var(--gray);
      @media (max-width: 991px) {
        border-right: 0;
        width: 100%;
        padding: 50px 0 20px 0;
        border-bottom: 1px solid var(--gray);
      }
      .title {
        font-size: 22px;
        font-family: "Font Bold";
        color: var(--white);
        padding: 25px 20px;
        border-bottom: 1px solid var(--gray);
        margin-bottom: 0;
        @media (min-width: 992px) and (max-width: 1199px) {
          padding: 15px;
          font-size: 18px;
        }
        @media (max-width: 991px) {
          border-bottom: 0;
          padding: 0;
        }
      }
      &__body {
        padding: 45px 20px 0 20px;
        @media (max-width: 991px) {
          padding: 30px 0 0 0;
        }
        &__div {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 30px;
        }
        .text-default-footer {
          display: block;
          text-decoration: none;
          transition: 500ms;
          &:hover,
          &:focus {
            cursor: pointer;
            opacity: 0.8;
          }
          @media (max-width: 991px) {
            width: 100%;
          }
          p {
            font-size: 16px;
            font-family: "Font Light";
            color: var(--white);
            margin-bottom: 0;
          }
          .shortly {
            &__title {
              font-size: 16px;
              font-family: "Font Light";
              color: rgba(255, 255, 255, 0.5);
              margin-bottom: 0;
            }
            &__div {
              width: 47px;
              height: 17px;
              display: flex;
              justify-content: center;
              align-items: center;
              background: var(--orange);
              border-radius: 11px;
              font-size: 7px;
              font-family: "Font Book";
              color: var(--white);
            }
          }
        }
      }
    }
    &-advantages,
    &-about {
      width: 25%;
      border-right: 1px solid var(--gray);
      @media (max-width: 991px) {
        border-right: 0;
        width: 100%;
        padding: 50px 0 20px 0;
        border-bottom: 1px solid var(--gray);
      }
      .title {
        font-size: 22px;
        font-family: "Font Bold";
        color: var(--white);
        padding: 25px 20px;
        border-bottom: 1px solid var(--gray);
        margin-bottom: 0;
        @media (min-width: 992px) and (max-width: 1199px) {
          padding: 15px;
          font-size: 18px;
        }
        @media (max-width: 991px) {
          padding: 0;
          border-bottom: 0;
        }
      }
      &__body {
        padding: 45px 20px 0 20px;
        @media (max-width: 991px) {
          padding: 30px 0 0 0;
        }
        &__div {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 30px;
        }
        a {
          display: block;
          width: 100%;
          font-size: 16px;
          font-family: "Font Light";
          color: var(--white);
          text-decoration: none;
          transition: 500ms;
          &:hover,
          &:focus {
            cursor: pointer;
            opacity: 0.8;
          }
          p {
            margin-bottom: 0;
          }
        }
      }
    }
    &-about {
      border-right: 0;
    }
  }
  &-copyright {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 40px;
    @media (max-width: 991px) {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
    }
    p {
      font-size: 16px;
      font-family: "Font Book";
      color: var(--white);
      margin-bottom: 0;
    }
    &__terms {
      display: flex;
      align-items: center;
      @media (max-width: 991px) {
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 24px;
      }
      &__div {
        @media (max-width: 991px) {
          width: 100%;
        }
      }
      a {
        display: block;
        font-size: 16px;
        font-family: "Font Book";
        color: var(--white);
        text-decoration: none;
        margin-right: 50px;
        margin-bottom: 0;
        transition: 500ms;
        &:hover,
        &:focus {
          cursor: pointer;
          opacity: 0.8;
        }
        @media (max-width: 991px) {
          margin-bottom: 24px;
          margin-right: 0;
        }
      }
    }
  }
}
</style>
